import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSeparator,
  FieldSet,
  FieldTitle,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { signInFormOptions } from "../shared";
import { Spinner } from "@/client/components/shad/spinner";
import { getUser } from "@/client/hooks/useUserQuery";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/client/components/shad/radio-group";
import { IconUserCircle } from "@tabler/icons-react";
import { Badge } from "@/client/components/shad/badge";

export const UserBlock = withForm({
  ...signInFormOptions,
  render: function Render({ form }) {
    const { data, isPending } = getUser();

    if (!data || isPending) return <Spinner />;

    return (
      <form.AppField name="id">
        {(field) => {
          const isInvalid =
            field.state.meta.isTouched && !field.state.meta.isValid;
          return (
            <FieldSet>
              <FieldLegend variant="title">Sign In</FieldLegend>
              <FieldDescription>
                Select a user from the list below
              </FieldDescription>
              <FieldGroup>
                <RadioGroup
                  name={field.name}
                  value={field.state.value?.toString()}
                  onValueChange={(e) => field.handleChange(Number(e))}
                >
                  {data.map((user) => {
                    return (
                      <FieldLabel
                        key={user.id}
                        htmlFor={`user-list-${user.id}`}
                      >
                        <Field
                          orientation="horizontal"
                          data-invalid={isInvalid}
                        >
                          <div>
                            <IconUserCircle size={32} />
                          </div>
                          <FieldContent>
                            <FieldTitle>
                              {user.firstName} {user.lastName}
                              <UserRoleBadge role={user.role} />
                            </FieldTitle>
                            <FieldDescription className="text-left">
                              {user.email}
                            </FieldDescription>
                          </FieldContent>
                          <RadioGroupItem
                            value={user.id.toString()}
                            id={`user-list-${user.id}`}
                            aria-invalid={isInvalid}
                          />
                        </Field>
                      </FieldLabel>
                    );
                  })}
                </RadioGroup>
              </FieldGroup>
            </FieldSet>
          );
        }}
      </form.AppField>
    );
  },
});

const UserRoleBadge = ({ role }: { role: string }) => {
  if (role === "ADMIN") {
    return (
      <Badge className="bg-purple-50 text-purple-700 dark:bg-purple-950 dark:text-purple-300">
        Admin
      </Badge>
    );
  }

  return (
    <Badge className="bg-sky-50 text-sky-700 dark:bg-sky-950 dark:text-sky-300">
      User
    </Badge>
  );
};
